import * as caseRule from './caseRule';
import * as courseware from './courseware';
import * as labelRelation from './labelRelation';
import * as logger from './logger';
import * as vip from './vip';

export const services = { caseRule, courseware, labelRelation, logger, vip };



// WEBPACK FOOTER //
// ./src/service/index.js